// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 792) return "bundle.af22c1b6e33836cd459ecd4904e2fab6.css";
	// return url for filenames based on template
	return "bundle." + chunkId + "." + {"235":"172611cadab463ad6254239f9bb6e384","531":"7bfa448fc39822fca9ba3dbfeafff02b"}[chunkId] + ".css";
};